exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".expando-d6fc5d9f{margin-top:10px}.spinner-cc272e3c{margin-bottom:10px}a.expandoButton-fd1d01fe{color:#FA6400;padding:4px 8px;visibility:hidden}.ExpandoCard-398d629e:hover a.expandoButton-fd1d01fe{visibility:visible;color:#FA6400}@media screen and (max-width: 800px){a.expandoButton-fd1d01fe{display:none}.expando-d6fc5d9f{display:none}}\n", ""]);

// Exports
exports.locals = {
	"expando": "expando-d6fc5d9f",
	"spinner": "spinner-cc272e3c",
	"expandoButton": "expandoButton-fd1d01fe",
	"ExpandoCard": "ExpandoCard-398d629e"
};